import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ type, onAction }) => {
  const emptyStates = {
    trips: {
      icon: 'Map',
      title: 'No Trips Yet',
      description: 'Start planning your Philippine adventure by creating your first itinerary with our AI-powered trip planner.',
      actionLabel: 'Create Trip',
      actionIcon: 'Plus'
    },
    favorites: {
      icon: 'Heart',
      title: 'No Favorites Saved',
      description: 'Explore amazing destinations across the Philippines and save your favorites for easy access later.',
      actionLabel: 'Discover Destinations',
      actionIcon: 'Compass'
    },
    bookings: {
      icon: 'Calendar',
      title: 'No Bookings Found',
      description: 'You haven\'t made any bookings yet. Browse our verified partners and secure your perfect accommodation.',
      actionLabel: 'Browse Hotels',
      actionIcon: 'Building2'
    }
  };

  const state = emptyStates?.[type] || emptyStates?.trips;

  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-primary/10 flex items-center justify-center mb-6">
        <Icon name={state?.icon} size={40} color="var(--color-primary)" />
      </div>
      <h3 className="text-xl md:text-2xl font-bold text-foreground mb-3 text-center">
        {state?.title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground text-center max-w-md mb-6">
        {state?.description}
      </p>
      <Button
        variant="default"
        size="lg"
        onClick={onAction}
        iconName={state?.actionIcon}
        iconPosition="left"
      >
        {state?.actionLabel}
      </Button>
    </div>
  );
};

export default EmptyState;